import { getBalance } from '@/unified-modules/wallet/wallet-library';
import { CasinoBalance, normalizeWalletResponse } from './normalize-balance';
import { fetchInGameBalanceEnrichment } from './fetch-in-game-balance-enrichment';

export const walletBalance = async (): Promise<CasinoBalance> => {
  const balances = await getBalance();

  if (!balances?.size) {
    return Promise.reject(new Error('No wallet balances found'));
  }

  const normalized = normalizeWalletResponse(balances);

  // Single source: overlay the FGP in-game balance here so both callers
  // (getBalanceData + UserDetails) read one enriched balance. The enrichment is
  // flag-gated and self-catching (returns null on off/failure), so a missing or
  // failed FGP call leaves the plain wallet balance untouched.
  const inGameBalance = await fetchInGameBalanceEnrichment();

  return { ...normalized, ...(inGameBalance ?? {}) };
};
